/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="iconStatus"
      bottom
      left
      id="snackbar"
      >{{ snackbarMessage }}
    </v-snackbar>
    <v-layout
      row
      :wrap="!$vuetify.breakpoint.mdAndUp"
      :class="{ 'fill-height': $vuetify.breakpoint.mdAndUp }"
    >
      <v-flex
        xs12
        md9
        order-xs2
        order-md1
        mb-3
        :class="{ 'fill-height': $vuetify.breakpoint.lgAndUp }"
      >
        <AlertList :itemPerPage="itemPerPage" :activeFilter="activeFilter" />
      </v-flex>
      <v-flex
        xs12
        md3
        order-xs1
        order-md2
        mb-3
        class="fill-height section-width"
      >
        <AlertSelection />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const momentTz = require("moment-timezone");
import AlertList from "@/components/Alert-v2/AlertList";
import AlertSelection from "@/components/Alert-v2/AlertSelection";

import { EventBus } from "@/services/event-bus";
import { mixin } from "@/util/mixin/index";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    AlertList,
    AlertSelection,
  },
  mixins: [mixin],
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      snackbarMessage: "Test",
      snackbar: false,
      iconStatus: "info",
      page: 1,
      itemPerPage: 50,
      filter: [
        {
          id: "severity",
          type: "select",
          attr: { outline: false },
          title: "Severity",
          value: [
            {
              color: "red",
              icon: "error_outline",
              text: "Critical",
              value: "critical",
            },
            {
              color: "red",
              icon: "error",
              text: "High",
              value: "high",
            },
            {
              color: "red",
              icon: "bug_report",
              text: "Medium",
              value: "medium",
            },
            {
              color: "red",
              icon: "warning",
              text: "Low",
              value: "low",
            },
            {
              color: "orange",
              icon: "warning",
              text: "Warning",
              value: "warning",
            },
            {
              color: "blue",
              icon: "warning",
              text: "Info",
              value: "modbus",
            },
          ],
        },
        {
          id: "status",
          type: "select",
          title: "Status",
          value: [
            { text: "New", value: "new" },
            { text: "Resolved", value: "resolved" },
            { text: "Acknowledge", value: "acknowledge" },
          ],
        },
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "sortBy",
          type: "select",
          title: "Sort",
          value: [
            {
              text: "Created Time",
              value: "created_timestamp",
            },
            {
              text: "Resolved Time",
              value: "resolved_timestamp",
            },
            {
              text: "Status",
              value: "status",
            },
            {
              text: "Code",
              value: "code",
            },
          ],
        },
      ],
      activeFilter: {},
    };
  },
  computed: {
    ...mapGetters("alert", ["device"]),
    ...mapGetters(['getSelectedPlantId', 'getActivePlantInfo', 'getActivePlantTimezone']),
    topic() {
      return `/alert/update/${this.getSelectedPlantId}/${
        this.device === "all" ? "#" : this.device
      }`;
    },
    activeDate() {
      return this.activeFilter.Date ? this.activeFilter.Date : {
        from: momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD'),
        to: momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
      }
    },
    activeServerity() {
      return this.activeFilter.severity
        ? this.activeFilter.severity
        : {
            text: "Critical",
            value: "critical",
          };
    },
    activeStatus() {
      return this.activeFilter.status
        ? this.activeFilter.status
        : { text: "New", value: "new" };
    },
    watchFilterChanges() {
      return `${this.activeDate.from} ${this.activeDate.to} ${this.activeServerity.value} ${this.activeStatus.value}`;
    },
  },
  mounted() {
    const Obj = {};
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach((child) => {
      if (
        (child.condition &&
          (!!child.considerStateAlways || child.condition(Obj[child.ref]))) ||
        !child.condition
      ) {
        if (child.type === "select") {
          if (typeof child.value === "function") {
            Obj[child.id] = child.value(Obj[child.ref]);
          } else {
            Obj[child.id] = child.value[0];
          }
        } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
          let parameters = ['from', 'to']
          parameters.forEach(key => {
            if (!Obj[child.id]) { Obj[child.id] = {} }
            Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
          })
        } else {
          Obj[child.id] = child.value;
        }
      }
    });
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit("initial:active_filter", Obj);

    this.fetchAlertLogs()
    EventBus.$on('alertPageNum', this.changePage)
    EventBus.$on('alertDownload', this.download)
    this.$mqtt.subscribe(this.topic)
    this.$mqtt.on('message', (topic, message) => {
      if (topic.startsWith('/alert/update')) {
        this.appendNewAlert(JSON.parse(message.toString()))
      }
    });
    EventBus.$on("alert:update", this.showSnackbar);
  },
  beforeDestroy() {
    EventBus.$off('alertPageNum', this.changePage)
    EventBus.$off('alertDownload', this.download)
    EventBus.$off('alert:update', this.showSnackbar)
    this.$mqtt.unsubscribe(this.topic)
  },
  methods: {
    ...mapActions("alert", [
      "fetchAlert",
      "downloadAlert",
      "appendNewAlert",
      "clear",
    ]),
    changePage(value) {
      this.page = value;
      this.fetchAlertLogs();
    },
    fetchAlertLogs() {
      const param = {
        plantId: this.getSelectedPlantId,
        dateFrom: this.activeDate.from,
        dateTo: this.activeDate.to,
        device: this.device,
        severity: this.activeServerity.value,
        status: this.activeStatus.value,
        page: this.page,
        itemPerPage: this.itemPerPage,
      };

      this.fetchAlert(param);
    },
    download() {
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getActivePlantInfo("plant_name"),
        dateFrom: this.activeDate.from,
        dateTo: this.activeDate.to,
        device: this.device,
        severity: this.activeServerity.value,
        status: this.activeStatus.value,
      };
      this.downloadAlert(param);
    },
    showSnackbar(payload) {
      this.snackbarMessage = payload.message;
      this.iconStatus = payload.status;
      this.snackbar = true;
      this.fetchAlertLogs();
    },
  },
  watch: {
    getSelectedPlantId() {
      this.clear()
      this.page = 1
      this.fetchAlertLogs()
    },
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    topic(newValue, oldValue) {
      this.$mqtt.unsubscribe(oldValue);
      this.$mqtt.subscribe(newValue);
    },
    watchFilterChanges() {
      this.page = 1;
      this.fetchAlertLogs();
    },
  },
};
</script>

<style>
.section-width {
  min-width: 340px;
}
</style>
